import React from "react";
import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import ImageArea from "../../../../Common/ImageArea";
import { Col } from "reactstrap";
import { MapReportTitle } from "../../Periodic/mapSchema";
export const titleOfReport = (testCode) => MapReportTitle[testCode];

const AirBrakeSupportingDocumentsFields = {
  heights: { header1: "40px" },
  classes: { header2: "" },
  inlineData: false,
  columns: [
    {
      title: "Description",
      colSpan: 8,
      centerAlign: true,
      className: "tbl-text-normal",
      accessor: "supportingDocumentsDescription",
      unBold: true,
    },

    {
      title: "Image",
      colSpan: 12,
      centerAlign: true,
      className: "tbl-text-normal",
      accessor: "supportingDocumentsImage",

      formatter: (id) => {
        return (
          <Col md="12">
            <ImageArea
              path="applicationresources"
              imagesList={[
                {
                  imgName: id,
                },
              ]}
              imageHeight={"300px"}
              extraStyle={{ whiteSpace: "normal" }}
            />
          </Col>
        );
      },
      unBold: true,
    },

    {
      title: "Inspector Name",
      colSpan: 4,
      centerAlign: true,
      className: "tbl-text-normal",
      accessor: "supportingDocuments_filledBy",
      unBold: true,
    },
  ],
};
const AirBrakeOtherFieldsData = (title, id, filledById) => {
  return {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: title,
        colSpan: 16,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: title,
        unBold: true,
        isValueOnly: true,
      },
      {
        title: title,
        colSpan: 4,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: id,
        unBold: true,
        isValueOnly: true,
        formatter: (vals) => {
          return <span style={{ fontSize: "14px" }}>{typeof vals === "boolean" ? (vals ? "YES" : " ") : " "}</span>;
        },
      },
      {
        title: title,
        colSpan: 4,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: filledById,
        unBold: true,
        isValueOnly: true,
      },
    ],
  };
};
export const getOtherActivityTable = (summary) => {
  const { otherActivity } = summary;
  const sectionHeader = {
    heights: { header1: "70px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Other Activity",
        colSpan: 24,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  };
  const TableHeader = {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Check Items",
        colSpan: 20,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
      {
        title: "Inspector Name",
        colSpan: 4,
        centerAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
    ],
  };
  const RowTemplate = AirBrakeOtherFieldsData("otherActivityDescription", "otherActivityCheckbox", "otherActivity_filledBy");
  return (
    <table className="table-bordered">
      <ReportTableSectionRenderer rowsData={{}} section={sectionHeader} />
      <ReportTableSectionRenderer rowsData={{}} section={TableHeader} />
      {otherActivity.map((e, i) => {
        return <ReportTableSectionRenderer rowsData={e} section={RowTemplate} key={i} />;
      })}
    </table>
  );
};
export const getSupportingDocuments = (summary) => {
  const { supportingDocuments } = summary;
  const sectionHeader = {
    heights: { header1: "70px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Supporting Documents",
        colSpan: 24,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  };
  return (
    <table className="table-bordered">
      <ReportTableSectionRenderer rowsData={{}} section={sectionHeader} />
      <ReportTableSectionRenderer rowsData={supportingDocuments} section={AirBrakeSupportingDocumentsFields} />
    </table>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/AirBrakeReports/AirBrakeReports/CommonFunctions.jsx